import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';
import moment, { Moment } from 'moment-timezone';

import { useCurrentUser } from '@lib/hooks';
import { selectCurrentMaster, selectUserSettings } from '@lib/selectors';

export type UseSettingSchedulerDatesResponse = {
  startDate: Moment | null;
  endDate: Moment | null;
};

export default function useSettingSchedulerDates(): UseSettingSchedulerDatesResponse {
  const currentUser = useCurrentUser();
  const currentMaster = useSelector(selectCurrentMaster);
  const settings = useSelector(selectUserSettings);
  const hoursAheadToShowAvailability = useMemo(() => _.get(settings, 'scheduler.hoursAheadToShowAvailability', 0), [
    settings,
  ]);
  const maxDaysToShow = useMemo(() => _.get(settings, 'scheduler.maxDaysToShow', 0), [settings]);
  const timezone = useMemo(
    () =>
      _.get(currentMaster, 'settings.timezone') ||
      _.get(currentUser, 'settings.timezone') ||
      (moment.tz.guess() as string),
    [currentMaster, currentUser],
  );

  const startDate = useMemo(
    () =>
      moment()
        .tz(timezone)
        .add(hoursAheadToShowAvailability, 'hours'),
    [hoursAheadToShowAvailability, timezone],
  );
  const endDate = useMemo(
    () =>
      moment(startDate)
        .add(maxDaysToShow - 1, 'days')
        .endOf('day'),
    [maxDaysToShow, startDate],
  );

  return {
    startDate,
    endDate,
  };
}
